module.exports = __webpack_public_path__ + "static/img/1520x500.5cbc3f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1520x500.jpg
// module id = 1346
// module chunks = 4